import { StyleRules } from '@material-ui/core';
import layout from '../../components/styles/layout';
import pxToRem from '../../utilities/pxToRem';
import type { Theme } from '../../utilities/types';

export default (theme: Theme): StyleRules => {
  const themed = layout(theme);
  return {
    welcomeButton: {
      margin: `${pxToRem(22)} 0`,
    },
    welcomeDescription: {
      marginTop: pxToRem(53),
    },
    aoapyDescription: {
      marginTop: pxToRem(150),
      [theme.breakpoints.up('lg')]: {
        marginLeft: pxToRem(-20),
        marginRight: pxToRem(-20),
        marginBottom: pxToRem(-30),
      },
      [theme.breakpoints.only('sm')]: {
        marginTop: pxToRem(420),
      },
      [theme.breakpoints.only('md')]: {
        marginTop: pxToRem(460),
      },
    },
    apyTextNote: {
      lineHeight: `${1.33} !important`,
    },
    apySubTextNotice: {
      lineHeight: `${1.4} !important`,
      fontSize: `${pxToRem(10)} !important`,
    },
    ...themed,
  };
};
